export const formatAuctionNumber = (value: string): string => {
    if (!value || value.length <= 4) {
        return value;
    }

    const newValue = value.split('').reverse();
    newValue.splice(4, 0, '/');
    return newValue.reverse().join('');
};
